var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './VideoCallLayout.module.scss';
export var VideoCallLayout = function (_a) {
    var localParticipant = _a.localParticipant, remoteParticipants = _a.remoteParticipants, controls = _a.controls;
    return (_jsxs("div", __assign({ className: "".concat(styles.wrapper, " min-h-widget") }, { children: [_jsx("div", __assign({ className: styles.remoteParticipants }, { children: remoteParticipants })), _jsx("div", __assign({ className: styles.localParticipant }, { children: localParticipant })), _jsx("div", __assign({ className: styles.controls }, { children: controls }))] })));
};
